
import { Component, Vue } from 'vue-property-decorator';
import notificationsStore from '../../notificationsStore';
import omegaup_Markdown from '../Markdown.vue';

@Component({
  components: {
    'omegaup-markdown': omegaup_Markdown,
  },
})
export default class GlobalNotifications extends Vue {
  get visible(): boolean {
    return notificationsStore.getters.isVisible;
  }

  get message(): string | null {
    return notificationsStore.getters.message;
  }

  get alertClass(): string {
    return notificationsStore.getters.alertClass;
  }

  get positionClass(): string {
    return notificationsStore.getters.positionClass;
  }

  dismiss(): void {
    notificationsStore.dispatch('dismissNotifications');
  }
}
